import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 保存用户信息
    userInfo: {},
    //再次体验
    isAgainTitle:{},
    //页面切换验证
    switchingMsg:'',
    //标题
    navTitle: '',
    //判断是不是VIP
    isVip: false,
    //存储unionId
    unionId:'',
    //RefererInfo
    Referer:'',
  },
  getters: {
    userInfo: state => state.userInfo,
    isAgainTitle: state => state.isAgainTitle,
    switchingMsg: state => state.switchingMsg,
    navTitle: state => state.navTitle,
    isVip: state => state.isVip,
    unionId: state => state.unionId,
    Referer: state => state.Referer
  },
  mutations: {
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    setIsAgainTitle(state, isAgainTitle) {
      state.isAgainTitle = isAgainTitle
    },
    //页面切换
    setSwitchingMsg(state, switchingMsg) {
      state.switchingMsg = switchingMsg
    },
    setNavTitle(state, navTitle) {
      state.navTitle = navTitle
    },
    setIsVip(state, isVip) {
      state.isVip = isVip
    },
    setUnionId(state, unionId) {
      state.unionId = unionId
    },
    setReferer(state, Referer) {
      state.Referer = Referer
    }
  },
  actions: {
  },
  plugins: [createPersistedState({
    storage: window.sessionStorage, // 或者 localStorage
  })],
  modules: {
  }
})
